import { render, staticRenderFns } from "./AccountInvite.vue?vue&type=template&id=308dbe12"
import script from "./AccountInvite.vue?vue&type=script&lang=js"
export * from "./AccountInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports